import { DatePicker, DateStringValue } from '@mantine/dates';
import React from 'react';
import { CommandDispatcher } from '../../../../concepts/commands/CommandDispatcher';
import { Colors } from '../../../../ui';
import { useResolve } from '../../../Container';
import { TextAlignment, TextSettings } from '../../../canvas/entities/TextConventions';
import { UIField } from '../../../canvas/entities/UIField';
import { useComponentObserver } from '../../../canvas/visualization/ComponentObserver';
import { PopperFieldEditor, PopperFieldEditorContentProps } from '../../../canvas/workspace/adapters/PopperFieldEditor';
import { Flexer } from '../../../dashboard/elements/LayoutElements';
import { JiraSprint } from '../JiraSprint';
import { jiraSprintSetEndDate, jiraSprintSetStartDate } from '../JiraSprintCommands';
import { JiraOAuthRequiredPopperContent } from './JiraOAuthRequiredPopperContent';

export const JiraSprintDateTextSettings = TextSettings.from({
    fontFamily: 'Rubik',
    fontColor: Colors.gray700,
    fontWeight: 400,
    fontSize: 12,
    lineHeight: 1.25,
    textMargin: [0, 4],
    fontStyle: 'normal',
    maxFontSize: null,
    textAlignH: TextAlignment.start,
    textAlignV: TextAlignment.middle,
});

// export const JiraSprintDateFormatter = (date: string) =>
//     !!date ? new Date(date).toLocaleDateString() : 'Not Set';

// const JiraSprintDateFieldEditor = ({ active, field, dateType }: UIFieldProps & { dateType: 'from' | 'to' }) => {
//     const dispatch = useResolve(CommandDispatcher);

//     const object = field.owner.cast(JiraSprint);
//     useComponentObserver(object);

//     const dateValue = dateType === 'from' ? object.record?.startDate : object.record?.endDate;
//     const [initialValue] = useState(dateValue ? new Date(dateValue).toLocaleDateString() : '');
//     const [value, setValue] = useState(initialValue);

//     const onChange = useCallback((nextValue: string) => {
//         setValue(nextValue);
//     }, []);

//     const onCommit = useCallback((finalValue: string) => {
//         if (finalValue === initialValue) return;
//         if (dateType === 'from') {
//             dispatch(jiraSprintSetStartDate, { targetId: object.id, startDate: finalValue });
//         }
//         else {
//             dispatch(jiraSprintSetEndDate, { targetId: object.id, endDate: finalValue });
//         }
//     }, [initialValue, object.id, dispatch, dateType]);

//     const onReject = () => dispatch(escape);

//     return <JiraOAuthRequired onReject={onReject}>
//         <SimpleTextFieldInput {...{
//             active,
//             field,
//             settings: JiraSprintDateTextSettings,
//             value,
//             onChange,
//             onCommit,
//             placeholder: dateType === 'from' ? 'Start Date' : 'End Date',
//         }} />
//     </JiraOAuthRequired>;
// };

const JiraSprintStartDateFieldEditor = ({ field, onClose }: PopperFieldEditorContentProps) => {

    const dispatch = useResolve(CommandDispatcher);
    const object = field.owner.cast(JiraSprint);
    useComponentObserver(object);

    const onChange = (startDate: DateStringValue) => {
        dispatch(jiraSprintSetStartDate, { targetId: object.id, startDate });
        onClose();
    };
    return <Flexer>
        <DatePicker
            value={object.record?.startDate}
            onChange={onChange}
        />
    </Flexer>;
};

const JiraSprintEndDateFieldEditor = ({ field, onClose }: PopperFieldEditorContentProps) => {

    const dispatch = useResolve(CommandDispatcher);
    const object = field.owner.cast(JiraSprint);
    useComponentObserver(object);

    const onChange = (endDate: DateStringValue) => {
        dispatch(jiraSprintSetEndDate, { targetId: object.id, endDate });
        onClose();
    };
    return <Flexer>
        <DatePicker
            value={object.record?.startDate}
            onChange={onChange}
        />
    </Flexer>;
};


export const JiraSprintFromDateField = (owner: JiraSprint): UIField => ({
    ui: PopperFieldEditor(JiraOAuthRequiredPopperContent(JiraSprintStartDateFieldEditor)),
    name: 'fromDate',
    bounds: owner.layout.fromDate,
    owner,
});

export const JiraSprintToDateField = (owner: JiraSprint): UIField => ({
    ui: PopperFieldEditor(JiraOAuthRequiredPopperContent(JiraSprintEndDateFieldEditor)),
    name: 'toDate',
    bounds: owner.layout.toDate,
    owner,
});
